(async () => {
    const baseComponent = await import(window.theme.modules.baseComponent);
    const { $fetch } = await import(window.theme.modules.utils);

    const CACHE_KEY = 'variant-provider';

    const chacheStore = {};
    const cache = {
        get: (item) => {
            return chacheStore[item];
        },
        set: (item, value) => {
            return chacheStore[item] = value;
        },
        has: (item) => {
            return (item in chacheStore);
        },
        list: chacheStore
    };
    
    function elementsToMap(elements) {
        return elements.reduce((acc, element) => {
            if (element.id) {
                acc[element.id] = element.cloneNode(true);
            }
            return acc;
        }, {});
    }

    
    customElements.define('product-variant-provider', class extends baseComponent.default {
        elements = {
            productMeta: '[data-product-meta]',
            listeners: '*product-variant-listener'
        }

        render() {
            this.disableCache = this.hasAttribute('no-cache');
            this.listenTo('variantChange', this._changeVariant.bind(this));
            this.listenTo('sellingPlanChange', this._onSellingPlanChange.bind(this));
            this._initState();            
        };

        async _initState() {
            this.currentState = { 
                variantId: this.initialVariantId,
                optionValueIds: this.initialOptionsState.split(','),
                variantImagePosition: this.initialImagePosition,
                sellingPlanId: this.initialSellingPlan
            };
            this._initCache();
        }

        _initCache() {
            if(this.disableCache) {
                return;
            }
            if (!cache.has(this.cacheKey)) {
                cache.set(this.cacheKey, {
                    listeners: elementsToMap(this.$listeners)
                });
                
                return;
            }
            // if we have cache on initilization it's mean this cache was initited by someone before
            // refresh contents on the next tick
            setTimeout(() => {
                this._publishUpdates();
            }, 20)
        }

        _onSellingPlanChange(e, data) {
            this.currentState.sellingPlanId = data.sellingPlanId;
            this._handleUpdate();
            
        }

        _changeVariant({ detail }) {
            const { optionValueId, optionIndex, variantId, imagePosition } = detail;
            this.currentState.optionValueIds[+optionIndex] = optionValueId;        
            this.currentState.variantId = variantId || undefined;
            this.currentState.variantImagePosition = imagePosition;          
            this._handleUpdate();
        }

        async _handleUpdate() {
            await this._updateCache();
            this._publishUpdates();
            this._updateProps();
            if (this.isProductPage) {
                this._updateBrowserHistory();
            }
            if (typeof GPOConfigs !== 'undefined' && GPOConfigs?.initialize) {
                GPOConfigs.initialize();
            }
        }

        async _updateCache() {
            if (cache.has(this.cacheKey)) return;
            const $listeners = await this._fetchDoc();
            
            cache.set(this.cacheKey, {
                listeners: elementsToMap($listeners),
            });
        }

        _updateProps() {
            this.setAttribute('initial-variant-id', this.currentState.variantId);
            this.setAttribute('initial-image-position', this.currentState.variantImagePosition);
            this.setAttribute('initial-selling-plan', this.currentState.sellingPlanId);
        }

        async _fetchDoc() {
            const doc = await $fetch(this.productURL, {
                before: this._loading(true),
                after: this._loading(false),
                params: {
                    selling_plan: this.currentState.sellingPlanId,
                    section_id: this.sectionId,
                    option_values: this.optionValueIdsString,
                },
                selectAll: `product-variant-listener`
            })
            return doc;
        }

        _publishUpdates() {
            this.forwardEvent('variantUpdate', {
                imagePosition: this.currentState.variantImagePosition,
                targets: cache.get(this.cacheKey).listeners      
            })
        }

        _loading(state) {
            return () => {
                this.forwardEvent(state ? 'variantLoading' : 'variantLoaded');
            }
        }
        
        get cacheKey() {
            return `${CACHE_KEY}-${this.sectionId}-${this.currentState.variantId}-${this.optionValueIdsString}-${this.currentState.sellingPlanId}`;
        }

        get optionValueIdsString() {
            return this.currentState.optionValueIds.toString();
        }

        _updateBrowserHistory() {
            window.history.replaceState({}, null, `${window.location.pathname}?${this.historyURLParams.toString()}`);
        }

        get historyURLParams() {
            const URLParams = new URLSearchParams({});
            if (this.currentState.variantId) {
                URLParams.set('variant', this.currentState.variantId);
            }
            // if (!this.currentState.variantId) { //NOTE: leave this here for now. The Dawn avoids this.
            //     URLParams.set('option_values', this.optionValueIdsString);
            // }
            this.currentState.sellingPlanId ? URLParams.set('selling_plan', this.currentState.sellingPlanId) : URLParams.delete('selling_plan');
            return new URLSearchParams(URLParams);
        }

        get isProductPage() {
            return this.hasAttribute('product-page');
        }
        get productURL() {
            return this.getAttribute('product-url');
        }
        get initialVariantId() {
            return this.getAttribute('initial-variant-id');
        }
        get initialImagePosition() {
            return this.getAttribute('initial-image-position');
        }
        get initialSellingPlan() {
            return this.getAttribute('initial-selling-plan');
        }
        get initialOptionsState() {
            return this.getAttribute('initial-options-state');
        }
    });
  })();
  